import { useEffect } from "react";
import { LuArrowUpRight } from "react-icons/lu";
import { Link } from "react-router-dom";

// Nando's UAE wordmark, from https://www.nandos.ae/svgs/nandos-logo.svg
// (viewBox trimmed to the artwork; the original has wide empty margins).
import logo from "../assets/nandos-logo.svg";
import { careersPath } from "../lib/paths";

import "../careers.css";

const NANDOS_SITE = "https://www.nandos.ae";
const FONT_ID = "cr-font-geist";
const FONT_HREF = "https://fonts.googleapis.com/css2?family=Geist:wght@400..700&display=swap";

// The careers font is loaded only when a careers page mounts, so the ESS app
// never pays for it.
function useCareersFont() {
  useEffect(() => {
    if (document.getElementById(FONT_ID)) return;
    const link = document.createElement("link");
    link.id = FONT_ID;
    link.rel = "stylesheet";
    link.href = FONT_HREF;
    document.head.appendChild(link);
  }, []);
}

export const Logo = () => (
  <Link to={careersPath()} className="cr-logo" aria-label="Nando's careers home">
    <img src={logo} alt="Nando's" width="125" height="23" />
  </Link>
);

// Sticky top bar. `title` shows beside the logo on wider screens; children
// replace the default links on the right.
export function TopBar({ title, children }) {
  return (
    <header className="cr-topbar">
      <div className="cr-wrap cr-topbar-inner">
        <Logo />
        {title && <span className="cr-topbar-title">{title}</span>}
        <nav className="cr-topbar-nav" aria-label="Careers">
          {children ?? (
            <>
              <Link to={careersPath()} className="cr-navlink">
                Open roles
              </Link>
              <a href={NANDOS_SITE} className="cr-navlink cr-navlink--wide" target="_blank" rel="noopener noreferrer">
                nandos.ae
                <LuArrowUpRight aria-hidden="true" />
              </a>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="cr-footer">
      <div className="cr-wrap cr-footer-inner">
        <Logo />
        <nav className="cr-footer-links" aria-label="Footer">
          <Link to={careersPath()}>Open roles</Link>
          <a href={NANDOS_SITE} target="_blank" rel="noopener noreferrer">
            Visit nandos.ae
            <LuArrowUpRight aria-hidden="true" />
          </a>
        </nav>
        <p className="cr-footer-copy">© {new Date().getFullYear()} Nando's UAE. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default function CareersShell({ className = "", children }) {
  useCareersFont();
  return (
    <div className={`cr ${className}`.trim()}>
      <a href="#cr-main" className="cr-skip">
        Skip to content
      </a>
      {children}
      <Footer />
    </div>
  );
}
